import React from "react";
import "../../styles/reports.css";

const ReportSummaryCards = ({ summary }) => {
  if (!summary) return null;

  const cards = [
    { title: "Total Tasks", value: summary.total || 0, color: "#007bff" },
    { title: "Pending", value: summary.pending || 0, color: "#ffc107" },
    { title: "In Progress", value: summary.inProgress || 0, color: "#17a2b8" },
    { title: "Completed", value: summary.completed || 0, color: "#28a745" },
    { title: "Overdue", value: summary.overdue || 0, color: "#dc3545" },
  ];

  return (
    <div className="report-summary-grid">
      {cards.map((card, idx) => (
        <div key={idx} className="summary-card" style={{ borderLeft: `6px solid ${card.color}` }}>
          <h4>{card.title}</h4>
          <p>{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default ReportSummaryCards;
